<template>
  <div class="notes-section">
    <label class="notes-section__label" for="actionNotes">
      <FontAwesomeIcon icon="note-sticky" class="me-1" />
      {{ $t("production_strategy.notes") }}
      <span class="notes-section__optional">
        · {{ $t("common.optional") }}
      </span>
    </label>
    <textarea
      id="actionNotes"
      class="form-control notes-section__textarea"
      rows="3"
      :value="notes ?? ''"
      @input="updateNotes(($event.target as HTMLTextAreaElement).value)"
      :placeholder="$t('production_strategy.notes_placeholder')"
    ></textarea>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const notes = defineModel<string | null>();

const updateNotes = (value: string) => {
  notes.value = value || null;
};

// Expose validation methods for parent component (notes are optional, so always valid)
defineExpose({
  isValid: () => true,
  touchAndValidate: () => true,
});
</script>

<style scoped lang="scss">
.notes-section__label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: var(--phoenix-gray-700);
  margin-bottom: 6px;
}

.notes-section__optional {
  color: var(--phoenix-gray-500);
  font-weight: 500;
}

.notes-section__textarea {
  resize: vertical;
}
</style>
